import { lazy } from "react";

const PagesRoutes = [


  //teste 

  {
    path: "/teste",
    component: lazy(() => import("../../view/pages/teste/index")),
    layout: "FullLayout",
  },




  //Registar

  //{
  //  path: "/register",
  //  component: lazy(() => import("../../view/pages/registrar/index")),
  //  layout: "FullLayout",

  //},

  // {
  //   path: "/login2",
  //   component: lazy(() => import("../../view/pages/registrar/login")),
  //   layout: "FullLayout",

  //  },



  // ADM
  {
    path: "/pages/Administrativo",
    component: lazy(() => import("../../view/pages/adm")),
    layout: "VerticalLayout",
    isProtected: true,
    permissions: ["administrativo"]
  },
  {
    path: "/pages/editar-sobre",
    component: lazy(() => import("../../view/pages/adm/EditarSobre")),
    layout: "VerticalLayout",
    isProtected: true,
    permissions: ["administrativo", "editor"]
  },
  {
    path: "/pages/editar-home",
    component: lazy(() => import("../../view/pages/adm/EditarHome")),
    layout: "VerticalLayout",
    isProtected: true,
    permissions: ["administrativo", "editor"]
  },
  {
    path: "/pages/editar-tesouraria",
    component: lazy(() => import("../../view/pages/adm/EditarTesouraria")),
    layout: "VerticalLayout",
    isProtected: true,
    permissions: ["administrativo", "editor"]
  },
  {
    path: "/pages/igrejas",
    component: lazy(() => import("../../view/pages/adm/Igrejas")),
    layout: "VerticalLayout",
    isProtected: true,
    permissions: ["administrativo", "editor"]
  },
  {
    path: "/pages/documentos",
    component: lazy(() => import("../../view/pages/adm/Documentos")),
    layout: "VerticalLayout",
    isProtected: true,
    permissions: ["administrativo", "editor"]
  },
  {
    path: "/pages/departamentos",
    component: lazy(() => import("../../view/pages/adm/Departamentos")),
    layout: "VerticalLayout",
    isProtected: true,
    permissions: ["administrativo", "editor"]
  },
  {
    path: "/pages/diretoria",
    component: lazy(() => import("../../view/pages/adm/Diretoria")),
    layout: "VerticalLayout",
    isProtected: true,
    permissions: ["administrativo", "editor"]
  },
  {
    path: "/pages/midias",
    component: lazy(() => import("../../view/pages/adm/Midias")),
    layout: "VerticalLayout",
    isProtected: true,
    permissions: ["administrativo", "editor"]
  },
  {
    path: "/pages/instagram-fotos",
    component: lazy(() => import("../../view/pages/adm/InstagramFotos")),
    layout: "VerticalLayout",
    isProtected: true,
    permissions: ["administrativo", "editor"]
  },
  //cibe
  {
    path: "/pages/cibe",
    component: lazy(() => import("../../view/pages/cibe/")),
    layout: "VerticalLayout",
    isProtected: true,
    permissions: ["cibe"],
  },
  {
    path: "/pages/stand",
    component: lazy(() => import("../../view/pages/cibe/StandDashboard")),
    layout: "VerticalLayout",
    isProtected: true,
    permissions: ["cibe"],
  },
  {
    path: "/pages/inscricao",
    component: lazy(() => import("../../view/pages/cibe/cibeg")),
    layout: "VerticalLayout",
    isProtected: true,
    permissions: ["cibe"],
  },
  {
    path: "/cibeg/adm",
    component: lazy(() => import("../../view/pages/cibe/cibeg")),
    layout: "VerticalLayout",
    isProtected: true,
    permissions: ["cibe"],
  },




  // Eroo
  {
    path: "/pages/error-404",
    component: lazy(() => import("../../view/pages/errors/404")),
    layout: "FullLayout",
  },
  {
    path: "/pages/manutencao",
    component: lazy(() => import("../../view/pages/errors/404/manutencao")),
    layout: "FullLayout",
  },


  // Login

  {
    path: "/login",
    component: lazy(() => import("../../view/pages/authentication-modern/login")),
    layout: "FullLayout",
  },

  {
    path: "/home",
    component: lazy(() => import("../../view/pages/home")),
    layout: "FullLayout",
  },

  // Páginas do menu principal
  {
    path: "/sobre",
    component: lazy(() => import("../../view/pages/sobre")),
    layout: "FullLayout",
  },
  {
    path: "/igrejeiros",
    component: lazy(() => import("../../view/pages/igrejeiros")),
    layout: "FullLayout",
  },
  {
    path: "/projetos",
    component: lazy(() => import("../../view/pages/projetos")),
    layout: "FullLayout",
  },
  {
    path: "/faça-parte",
    component: lazy(() => import("../../view/pages/tesouraria")),
    layout: "FullLayout",
  },
  {
    path: "/eventos",
    component: lazy(() => import("../../view/pages/eventos")),
    layout: "FullLayout",
  },
  {
    path: "/galeria",
    component: lazy(() => import("../../view/pages/galeria")),
    layout: "FullLayout",
  },
  {
    path: "/diretoria",
    component: lazy(() => import("../../view/pages/diretoria")),
    layout: "FullLayout",
  },
  {
    path: "/dizimos-e-ofertas",
    component: lazy(() => import("../../view/pages/publicidade")),
    layout: "FullLayout",
  },

  {
    path: "/cibeg",
    component: lazy(() => import("../../view/pages/cibeghome")),
    layout: "FullLayout",
  },
  {
    path: "/cibeg/info",
    component: lazy(() => import("../../view/pages/cibeghome/EventInfoPage")),
    layout: "FullLayout",
  },
  {
    path: "/umadego",
    component: lazy(() => import("../../view/pages/umadego/GaleriaFotos")),
    layout: "FullLayout",
  },


  {
    path: "/cibeg/inscricao",
    component: lazy(() => import("../../view/pages/cibeg/inscrição")),
    layout: "FullLayout",
  },
  {
    path: "/cibeg/confirmar-pagamento",
    component: lazy(() => import("../../view/pages/cibeg/confirmação")),
    layout: "FullLayout",
  },
  {
    path: "/cibeg/pagamento",
    component: lazy(() => import("../../view/pages/cibeg/pagamento")),
    layout: "FullLayout",
  },



  //Usuarios

  {
    path: "/personel-information",
    component: lazy(() => import("../../view/pages/profile/personel-information")),
    layout: "VerticalLayout",
    isProtected: true,
  },


];

export default PagesRoutes;